import React from "react";

const reasons = [
  {
    accentColor: "#2563EB", bgColor: "#EFF6FF", title: "Prepared at Home",
    desc: "Not a factory. Not a warehouse. Every product is made in a real home kitchen with the same care you'd expect from family.",
    icon: (<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" /></svg>),
  },
  {
    accentColor: "#15803D", bgColor: "#F0FDF4", title: "Zero Preservatives",
    desc: "No chemicals, no shortcuts. We rely on traditional preservation methods — the way it's always been done in South Indian homes.",
    icon: (<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#15803D" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></svg>),
  },
  {
    accentColor: "#EA580C", bgColor: "#FFF7ED", title: "Two Generations of Expertise",
    desc: "Our mother-in-law brings decades of Tirunelveli mastery; our daughter-in-law adds Andhra finesse. Together, unbeatable.",
    icon: (<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#EA580C" strokeWidth="2"><circle cx="12" cy="8" r="6" /><path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11" /></svg>),
  },
  {
    accentColor: "#0369A1", bgColor: "#F0F9FF", title: "Honest Ingredients",
    desc: "Only farm-sourced, organic ingredients. We know what goes in — and we're proud to tell you every single one.",
    icon: (<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#0369A1" strokeWidth="2"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" /><line x1="7" y1="7" x2="7.01" y2="7" /></svg>),
  },
  {
    accentColor: "#1E40AF", bgColor: "#DBEAFE", title: "Small Batches, Big Quality",
    desc: "We never mass-produce. Small batches mean every jar gets the attention it deserves — tasted, checked, and packed with care.",
    icon: (<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#1E40AF" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>),
  },
  {
    accentColor: "#166534", bgColor: "#DCFCE7", title: "Authentically South Indian",
    desc: "No fusion, no compromise. Our recipes are rooted in the kitchens of Tirunelveli and Andhra — unchanged and unapologetic.",
    icon: (<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#166534" strokeWidth="2"><polyline points="20 6 9 17 4 12" /></svg>),
  },
];

const stats = [
  { value: "100%", label: "Natural" },
  { value: "0",    label: "Preservatives" },
  { value: "2",    label: "Traditions" },
  { value: "∞",   label: "Love" },
];

const KarpagamAbout = () => {
  return (
    <div style={{ fontFamily: "'Inter', sans-serif", background: "#F8FAFC", margin: 0, padding: 0 }}>

      <style>{`
        @media (max-width: 768px) {
          .hero-flex       { flex-direction: column !important; }
          .hero-img        { width: 100% !important; height: 300px !important; }
          .story-flex      { flex-direction: column !important; }
          .story-img       { width: 100% !important; height: 280px !important; }
          .tradition-flex  { flex-direction: column !important; }
          .tradition-img   { width: 100% !important; height: 260px !important; }
        }
      `}</style>

    

      {/* ══════════════════════════════════════
          4 Value Cards
      ══════════════════════════════════════ */}
      <div style={{ width: "100%", padding: "60px 20px 40px", maxWidth: "1200px", margin: "0 auto", boxSizing: "border-box" }}>
        <div style={{ textAlign: "center", marginBottom: "40px" }}>
          <p style={{ fontSize: "11px", letterSpacing: "3px", color: "#2563EB", textTransform: "uppercase", margin: "0 0 8px" }}>What We Stand For</p>
          <h2 style={{ fontSize: "26px", fontWeight: 600, color: "#1E3A8A", margin: 0 }}>Our Core Values</h2>
          <div style={{ width: "50px", height: "3px", background: "#EA580C", margin: "12px auto 0" }} />
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: "24px", marginBottom: "60px" }}>
          {[
            { color: "#2563EB", bg: "#EFF6FF", icon: "🏠", title: "Made with Love",        desc: "Every product is lovingly prepared by a mother-in-law and daughter-in-law team, carrying forward generations of kitchen wisdom." },
            { color: "#EA580C", bg: "#FFF7ED", icon: "⏰", title: "Time-Honoured Recipes", desc: "Rooted in the rich culinary heritage of Tirunelveli and Andhra, our recipes have been passed down and perfected over decades." },
            { color: "#16a34a", bg: "#F0FDF4", icon: "🌿", title: "100% Natural & Organic", desc: "We use only natural, organic ingredients — no preservatives, no artificial colours. Pure goodness in every jar and packet." },
            { color: "#0891b2", bg: "#F0FDFA", icon: "🏡", title: "Homemade Authenticity",  desc: "Crafted in small batches at home, every product reflects the care and authenticity of a home kitchen — never factory-made." },
          ].map((c, i) => (
            <div key={i} style={{
              background: "#fff", borderRadius: "12px", border: "1px solid #E2E8F0",
              padding: "28px 24px", borderTop: `4px solid ${c.color}`,
              transition: "transform 0.2s, box-shadow 0.2s",
            }}>
              <div style={{ width: "48px", height: "48px", borderRadius: "50%", background: c.bg, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "16px", fontSize: "22px" }}>
                {c.icon}
              </div>
              <h3 style={{ fontSize: "16px", fontWeight: 600, color: "#1E3A8A", margin: "0 0 10px" }}>{c.title}</h3>
              <p style={{ fontSize: "14px", color: "#475569", lineHeight: 1.7, margin: 0 }}>{c.desc}</p>
            </div>
          ))}
        </div>

        {/* ══════════════════════════════════════
            BRAND STORY — Content Left | Image Right
        ══════════════════════════════════════ */}
        <div className="story-flex" style={{
          display: "flex", borderRadius: "20px", overflow: "hidden",
          marginBottom: "60px", boxShadow: "0 20px 60px rgba(30,58,138,0.15)",
        }}>
          {/* Left — Content */}
          <div style={{
            flex: 1, background: "#1E3A8A", padding: "50px 44px",
            display: "flex", flexDirection: "column", justifyContent: "center",
          }}>
            <p style={{ fontSize: "11px", letterSpacing: "3px", color: "#FB923C", textTransform: "uppercase", margin: "0 0 16px" }}>Who We Are</p>
            <h2 style={{ fontSize: "26px", fontWeight: 700, color: "#fff", margin: "0 0 20px", lineHeight: 1.4 }}>
              A Story Born in the <span style={{ color: "#4ADE80" }}>Kitchen</span>
            </h2>
            <p style={{ fontSize: "15px", color: "#BFDBFE", lineHeight: 1.8, margin: "0 0 24px" }}>
              Karpagam Homemade is a brand dedicated to producing high-quality organic food products, lovingly prepared by a{" "}
              <span style={{ color: "#FB923C", fontWeight: 600 }}>mother-in-law and daughter-in-law team</span>. Our offerings reflect a unique blend of traditional{" "}
              <span style={{ color: "#4ADE80", fontWeight: 600 }}>Andhra cuisine</span> and the rich culinary heritage of{" "}
              <span style={{ color: "#4ADE80", fontWeight: 600 }}>Tirunelveli, South India</span>.
            </p>
            <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
              {["No Preservatives", "100% Organic", "Authentic Recipes"].map(t => (
                <span key={t} style={{ background: "rgba(255,255,255,0.1)", color: "#fff", padding: "6px 16px", borderRadius: "20px", fontSize: "12px", border: "1px solid rgba(255,255,255,0.2)" }}>{t}</span>
              ))}
            </div>
          </div>

          {/* Right — Image */}
          <div className="story-img" style={{ width: "45%", position: "relative", minHeight: "360px", overflow: "hidden" }}>
            <img
              src="https://images.unsplash.com/photo-1505935428862-770b6f24f629?w=800&q=80"
              alt="Traditional cooking"
              style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
            />
            <div style={{
              position: "absolute", inset: 0,
              background: "linear-gradient(to right, rgba(30,58,138,0.4), transparent)",
            }} />
          </div>
        </div>

        {/* ══════════════════════════════════════
            TWO TRADITIONS — Image Left | Content Right
        ══════════════════════════════════════ */}
        <div className="tradition-flex" style={{
          display: "flex", borderRadius: "20px", overflow: "hidden",
          border: "1px solid #E2E8F0", marginBottom: "60px",
          boxShadow: "0 4px 24px rgba(0,0,0,0.06)",
        }}>
          {/* Left — Image */}
          <div className="tradition-img" style={{ width: "30%", position: "relative", overflow: "hidden", minHeight: "250px" }}>
            <img
              src="https://images.unsplash.com/photo-1596797038530-2c107229654b?w=800&q=80"
              alt="South Indian spices"
              style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
            />
            <div style={{
              position: "absolute", inset: 0,
              background: "linear-gradient(to left, rgba(255,247,237,0.3), rgba(240,253,244,0.3))",
            }} />
          </div>

          {/* Right — Content */}
          <div style={{
            flex: 1, background: "#fff", padding: "50px 44px",
            display: "flex", flexDirection: "column", justifyContent: "center",
          }}>
           <h2 style={{ fontSize: "24px", fontWeight: 700, color: "#1E3A8A", margin: "0 0 6px" }}>Two Traditions, One Kitchen</h2>
<div style={{ width: "50px", height: "3px", background: "#EA580C", marginBottom: "16px" }} />

{/* ← Description added here */}
<p style={{ fontSize: "14px", color: "#475569", lineHeight: 1.8, margin: "0 0 24px" }}>
  What happens when two great culinary traditions come together under one roof? 
  Magic. Our kitchen blends the bold, fiery soul of <strong style={{ color: "#EA580C" }}>Andhra cuisine</strong> with 
  the fragrant, coconut-rich warmth of <strong style={{ color: "#16a34a" }}>Tirunelveli heritage</strong> — 
  creating flavours that are truly one of a kind.
</p>
            <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
              <div style={{ display: "flex", gap: "16px", alignItems: "flex-start" }}>
                <div style={{ width: "52px", height: "52px", borderRadius: "50%", background: "#FFF7ED", border: "2px solid #EA580C", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "22px", flexShrink: 0 }}>🌶</div>
                <div>
                  <h3 style={{ fontSize: "15px", fontWeight: 700, color: "#EA580C", margin: "0 0 6px" }}>Andhra Flavours</h3>
                  <p style={{ fontSize: "13px", color: "#475569", lineHeight: 1.7, margin: 0 }}>Bold, spicy, and vibrant — the fiery soul of Andhra cooking brought to life through chutneys, pickles, and masalas.</p>
                </div>
              </div>
              <div style={{ display: "flex", gap: "16px", alignItems: "flex-start" }}>
                <div style={{ width: "52px", height: "52px", borderRadius: "50%", background: "#F0FDF4", border: "2px solid #16a34a", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "22px", flexShrink: 0 }}>🥥</div>
                <div>
                  <h3 style={{ fontSize: "15px", fontWeight: 700, color: "#16a34a", margin: "0 0 6px" }}>Tirunelveli Heritage</h3>
                  <p style={{ fontSize: "13px", color: "#475569", lineHeight: 1.7, margin: 0 }}>Fragrant, coconut-rich, and deeply rooted — the soulful flavours of Tirunelveli's culinary traditions in every bite.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Promise Badges */}
        <div style={{ textAlign: "center", padding: "0 16px 56px" }}>
          <p style={{ fontSize: "11px", letterSpacing: "3px", color: "#2563EB", textTransform: "uppercase", margin: "0 0 12px" }}>Our Promise</p>
          <div style={{ display: "flex", justifyContent: "center", gap: "12px", flexWrap: "wrap" }}>
            {[["#1E3A8A","No Preservatives"],["#16a34a","100% Organic"],["#EA580C","Small Batch"],["#0891b2","Authentic Recipes"]].map(([bg, label]) => (
              <div key={label} style={{ background: bg, color: "#fff", padding: "8px 20px", borderRadius: "24px", fontSize: "13px", fontWeight: 500 }}>{label}</div>
            ))}
          </div>
        </div>
      </div>

      {/* ══════════════════════════════════════
          WHY CHOOSE US
      ══════════════════════════════════════ */}
      <div style={{ background: "#1E3A8A", padding: "48px 20px 36px", textAlign: "center" }}>
        <h2 style={{ fontSize: "28px", color: "#ffffff", margin: "0 0 14px", fontWeight: 500 }}>Why Choose Us?</h2>
        <div style={{ width: "56px", height: "3px", background: "#FB923C", margin: "0 auto 18px" }} />
      </div>

      <div style={{ width: "100%", padding: "40px 20px", maxWidth: "1200px", margin: "0 auto", boxSizing: "border-box" }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "24px", marginBottom: "48px" }}>
          {reasons.map((r, i) => (
            <div key={i} style={{ background: "#fff", borderRadius: "12px", border: "1px solid #E2E8F0", padding: "28px 20px", textAlign: "center", boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.05)" }}>
              <div style={{ width: "60px", height: "60px", borderRadius: "50%", background: r.bgColor, border: `2px solid ${r.accentColor}`, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px" }}>
                {r.icon}
              </div>
              <h3 style={{ fontSize: "15px", fontWeight: 600, color: "#1E3A8A", margin: "0 0 10px" }}>{r.title}</h3>
              <p style={{ fontSize: "13px", color: "#475569", lineHeight: 1.7, margin: 0 }}>{r.desc}</p>
            </div>
          ))}
        </div>

        {/* Stats Bar */}
        <div style={{ background: "#1E3A8A", borderRadius: "16px", padding: "20px", display: "flex", flexWrap: "wrap", justifyContent: "space-around", textAlign: "center" }}>
          {stats.map((s, i) => (
            <div key={i} style={{ padding: "20px", minWidth: "120px" }}>
              <p style={{ fontSize: "32px", fontWeight: 600, color: i % 2 === 0 ? "#4ADE80" : "#FB923C", margin: "0 0 6px" }}>{s.value}</p>
              <p style={{ fontSize: "12px", color: "#BFDBFE", margin: 0, letterSpacing: "1px", textTransform: "uppercase" }}>{s.label}</p>
            </div>
          ))}
        </div>
      </div>

    </div>
  );
};

export default KarpagamAbout;